import * as constants from "./constants";
import {ENDPOINT} from "./constants";
import {getCustomerGuid} from "./customer";

const buildQuery = function (query) {
	const params = new URLSearchParams(query)
	return params.toString();
}

export const getData = (endpoint, query = {}, options = {}) => {
	let url = ENDPOINT + "subscription.api/" + endpoint;
	if (query) {
		url += "?" + buildQuery(query)
	}

	return $.ajax({
		url,
		...options,
	});
}

export const postData = (endpoint, data, query = {}, options = {}) => {
	let url = ENDPOINT + "subscription.api/" + endpoint;
	if (query) {
		url += "?" + buildQuery(query)
	}

	return $.ajax({
		url,
		method: 'POST',
		data: JSON.stringify(data),
		...options,
	});
}

export const patchData = (endpoint, data, query = {}, options = {}) => {
	let url = ENDPOINT + "subscription.api/" + endpoint;
	if (query) {
		url += "?" + buildQuery(query)
	}

	return $.ajax({
		url,
		method: 'PATCH',
		data: JSON.stringify(data),
		...options,
	});
}

export const deleteData = (endpoint, query, options = {}) => {
	let url = ENDPOINT + "subscription.api/" + endpoint;
	if (query) {
		url += "?" + buildQuery(query)
	}

	return $.ajax({
		url,
		method: 'DELETE',
		...options,
	});
}